<template>
    <b-notification
        v-if="! tenancy.ForwardingAddressFK"
        class="vertically-aligned horizontally-spaced"
        :closable="false"
    >
        Each tenancy requires an alternative address to contact you after you move out.

        <b-button
            rounded
            size="is-small"
            @click.prevent="showModal()"
        >
            Add address
        </b-button>
    </b-notification>
</template>

<script>
import { mapState } from 'vuex';
import ForwardingAddressModal from '../components/ForwardingAddressModal.vue';

export default {
    computed: {
        ...mapState('tenancyProperty', [
            'tenancy',
        ]),
    },

    methods: {
        showModal() {
            this.$buefy.modal.open({
                parent: this,
                component: ForwardingAddressModal,
                hasModalCard: true,
            });
        },
    },
};
</script>
